<template>
  <div class="profile">
    <div class="avatar" :style="setAvatar()">
      <i class="material-icons" v-if="!doesAvatarExist()">person</i>
    </div>
    <div class="information">
      <span>{{user.name}}</span>
      <small>{{location.name}}</small>
    </div>
    <span style="flex: auto"/>
    <img :src="location.avatarUrl" height="50" :alt="location.name">
  </div>
</template>

<script>
  export default {
    name: "UserProfile",
    computed: {
      user() {
        return this.$store.getters.user;
      },
      location() {
        return this.$store.getters.location;
      }
    },
    methods: {
      setAvatar() {
        return this.user.photoUrl === null
          ? {
            'background-color': '#f2f1f1',
            'color': '#b1b1b1',
          }
          : {
            'background-image': `url(${this.user.photoUrl}`,
          };
      },
      doesAvatarExist() {
        return this.user.photoUrl !== null;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .profile {
    display: flex;
    padding: 8px 16px;
    align-items: center;

    .avatar {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      background-size: cover;
    }

    .information {
      display: flex;
      flex-direction: column;

      small {
        color: var(--text-secondary);
      }
    }
  }
</style>
